export default __webpack_public_path__ + "87fd5131025aab7bc5e81782ddd3ad45.png";